import React, { createElement, useEffect, useState } from 'react';
import './index.scss';
import { RadarChart } from 'bizcharts';
import { Message } from '@alifd/next';
import { previewDataByField } from '../../../api/common/index';
import { dealArray, dealOrderByBoList, dealFieldByList } from '../../../utils';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
const IRadarChart = (props, ref) => {
    const { dataSource, data, meta, colors, hasTitle, titleText, ...other } = props;
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    const [idata, setIdata] = useState([]);
    const [angle, setAngle] = useState('item');
    const [radius, setRadius] = useState('score');
    const [series, setSeries] = useState('user');
    useEffect(() => {
        setError(false);
        try {
            if (dataSource?.angle.length && dataSource?.radius.length) {
                const limit = dataSource?.limit || [100];
                if (limit[0] > 1000) {
                    Message.error('最多显示前1000条!');
                    return;
                }
                const fl = dataSource?.filter || [];
                const params = {
                    groupId: dataSource.dataset.id,
                    type: 'RadarChart',
                    fieldList: dealFieldByList([
                        ...dataSource.angle,
                        ...dataSource.radius,
                        ...dataSource.group,
                    ]),
                    horizontalAxis: dealArray(dataSource.angle),
                    longitudinalAxis: dealArray(dataSource.radius).map((e) => ({
                        ...e,
                        aggregateType: e?.aggregateType || 'COUNT',
                    })),
                    groupAxis: dealArray(dataSource.group),
                    orderByBoList: dealOrderByBoList([...dataSource.angle, ...dataSource.group]),
                    resultCount: limit[0] === undefined ? 100 : limit[0],
                    customFilterVo: fl[0] === undefined
                        ? null
                        : {
                            logic: 'and',
                            filterVos: [dataSource?.filter[0] || null].filter((e) => e),
                        },
                };
                previewDataByField(params).then((res) => {
                    const fields = res?.data?.fields;
                    if (!fields) {
                        Message.error(res?.msg);
                        return;
                    }
                    const an = fields.find((e) => e.id === dataSource.angle[0].id)?.fieldShortName || 'defalut';
                    const ra = fields.find((e) => e.id === dataSource.radius[0].id)?.fieldShortName || 'defalut';
                    const se = fields.find((e) => e.id === dataSource.group[0]?.id)?.fieldShortName || 'defalut';
                    const tempData = res.data.data.map((e) => {
                        for (let item of dataSource.radius) {
                            e[item.fieldShortName] = Number(e[item.fieldShortName]);
                        }
                        if (!dataSource.group.length) {
                            e.defalut = '默认';
                        }
                        return e;
                    });
                    setAngle(an);
                    setRadius(ra);
                    setSeries(se);
                    setIdata(tempData);
                });
            }
            else {
                setAngle('item');
                setRadius('score');
                setSeries('user');
                setIdata(data);
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('初始化数据出错,请检查数据来源是否合法或更新组件');
        }
    }, [dataSource]);
    const colorArr = colors ? colors?.split(',') : [];
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref, errmsg: errmsg })) : (createElement("div", { ref: ref, className: "base_bg" },
        hasTitle ? (createElement("div", { className: "datasettitle" }, titleText || dataSource?.dataset?.name)) : null,
        createElement(RadarChart, Object.assign({ forceUpdate: true, data: idata }, other, { color: colorArr, angleField: angle, radiusField: radius, seriesField: series }))))));
};
export default React.forwardRef(IRadarChart);
